<template>
  <v-dialog
    v-model="isDialogOpen"
    max-width="800"
    @click:outside="onClose"
    @keydown.esc="onClose"
  >
    <v-card>
      <v-toolbar dark color="blue darken-3" flat>
        <v-toolbar-title
          title="Слои, доступные для синхронизации"
        >
          Слои, доступные для синхронизации
        </v-toolbar-title>

        <div class="flex-grow-1" />

        <v-text-field
          v-model="searchQuery"
          label="Поиск по названию"
          prepend-inner-icon="search"
          hide-details
          single-line
          clearable
          flat
        />
      </v-toolbar>

      <v-card-text>
        <v-data-table
          height="400"
          item-key="id"
          class="elevation-0"
          no-data-text="Нет данных"
          loading-text="Загрузка данных"
          hide-default-footer
          fixed-header
          :loading="isLoading"
          :items="filteredList"
          :headers="headers"
          :options.sync="options"
        >
          <template #header.id>
            <v-checkbox @change="checkAllLayers($event)" />
          </template>

          <template #item.id="{ item }">
            <v-checkbox
              :value="!!layersForSync.find(layerID => layerID === item.id)"
              @change="addLayer(item.id)"
            />
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1" />
        <v-btn
          color="blue darken-1"
          text
          @click="onClose"
        >
          Отмена
        </v-btn>

        <v-btn
          color="success darken-1"
          text
          :disabled="!hasLayersForSync"
          @click="addLayersSync"
        >
          Синхронизация
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';

const INIT_HEADERS = [
  {
    value: 'name',
    key: 'name',
    text: 'Название слоя',
    sortable: true,
    skip: true,
  },
  {
    value: 'id',
    key: 'id',
    sortable: false,
  },
];

export default {
  name: 'export-layer-sync-dialog',

  props: {
    isDialogOpen: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    layersForSync: [],
    searchQuery: '',
    options: {
      itemsPerPage: -1,
    },
    isLoading: false,
  }),

  computed: {
    ...mapState('layersSync', ['layersList']),

    hasLayersForSync() {
      return !!this.layersForSync.length;
    },

    filteredList() {
      if (this.searchQuery) {
        return this.layersList
          .filter(item => item.name.toLowerCase().indexOf(this.searchQuery.toLowerCase()) !== -1);
      }
      return this.layersList;
    },
  },

  async created() {
    this.headers = INIT_HEADERS;

    try {
      this.isLoading = true;
      await this.getLayersList();
    } catch (error) {
      console.error(error);
    } finally {
      this.isLoading = false;
    }
  },

  beforeDestroy() {
    this.layersForSync = [];
  },

  methods: {
    ...mapActions('layersSync', ['getLayersList']),

    addLayer(id) {
      const index = this.layersForSync.indexOf(id);
      if (index === -1) this.layersForSync.push(id);
      else this.layersForSync.splice(index, 1);
    },

    checkAllLayers(checked) {
      if (checked) this.layersForSync = this.filteredList.map(item => item.id);
      else this.layersForSync = [];
    },

    addLayersSync() {
      this.$emit('add-layers-sync', this.layersForSync);
    },

    onClose() {
      this.$emit('closed');
    },
  },
};
</script>
